// Bus d'événements de la vitrine → plugins. ZÉRO dépendance, zéro effet
// tant qu'aucun plugin n'écoute : le cœur de la boutique émet
// (`emitPluginEvent("add_to_cart", {…})`) sans savoir si un plugin de suivi
// est actif, et n'est jamais ralenti ni cassé par un écouteur défaillant.
//
// Les écouteurs sont des plugins montés par PluginHost.jsx. Chaque appel
// d'écouteur est isolé : une exception dans un plugin ne remonte jamais
// jusqu'au composant qui a émis l'événement.

const listeners = new Set();

export function emitPluginEvent(name, props = {}) {
  if (!name || listeners.size === 0) return;
  for (const listener of listeners) {
    try {
      listener(name, props);
    } catch (e) {
      /* un plugin défaillant ne casse pas la boutique */
    }
  }
}

export function subscribePluginEvents(listener) {
  if (typeof listener !== "function") return () => {};
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Pour les tests uniquement.
export function _resetPluginBus() {
  listeners.clear();
}
